import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import { getAppPartner } from '../Auth/authSelectors.js';
import { getImpersonationSelector } from '../../app/appSelectors.js';
import { logoutAction } from '../Auth/authActions.js';
import { ImpersonationBannerStyled } from './styled/ImpersonationBannerStyled.js';

/**
 * Sticky warning when an admin views the cabinet as a partner.
 */
function ImpersonationBanner() {
    const dispatch = useDispatch();
    const impersonation = useSelector(getImpersonationSelector);
    const partner = useSelector(getAppPartner);

    const exitHandler = useCallback(() => {
        dispatch(logoutAction());
        window.setTimeout(() => {
            window.close();
        }, 100);
    }, [dispatch]);

    if (!impersonation) {
        return null;
    }

    return (
        <ImpersonationBannerStyled role="alert">
            <span>
                Admin view: partner #{partner?.partner_uid}
            </span>
            <Button variant="light" size="sm" onClick={exitHandler}>
                Exit
            </Button>
        </ImpersonationBannerStyled>
    );
}

export default ImpersonationBanner;
